import React from "react";
import { UserAuth } from "../../context/AuthContext";

import { Player } from "react-tuby";
import "react-tuby/css/main.css";

import "./styles.css";

const videoPlayer = (props) => {
  var url = props.location.params.url;
  var poster = props.location.params.poster;
  var title = props.location.params.title;
  const { user } = UserAuth();
console.log(user)
  return (
    <>
      {/* <PageTitle title={title}  /> */}
      <h1 style={{ textAlign: "center" }}>{title}</h1>
      <div className="overlay">
        <h2>{user.displayName}</h2>
        <h2>{user.email}</h2>
      </div>
      <video
        className="video_player"
        controls
        controlsList="nodownload nofullscreen"
        autoPlay
        width="100%"
        height="540px"
        poster={poster}
      >
        <source src={url} type="video/webm" />
      </video>
      {/* <Player
        src={url}
        dimensions={{ width: "100%", height: "720px" }}
        poster={poster}
        keyboardShortcut={{
          forward: true,
          rewind: true,
        }}
      >
        {(ref, props) => (
          <video
            ref={ref}
            {...props}
            controlsList="nodownload nofullscreen"
            preload="metadata"
            autoPlay
          />
        )}
        style={{position: "absolute", zIndex: "1", justifyContent: "center", alignItems: "center", textAlign: "center"}}
      </Player> */}
    </>
  );
};

export default videoPlayer;
